import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox } from "@components";
import { ProcurementDemandListTableColumn } from "./ProcurementDemandListTableColumn";

import { useDemandList } from "@hooks/procurements/demand/useDemandList";
import { useEffect, useState } from "react";
import { DemandResponseType } from "@type/procurements/demand";
import { Pagination } from "@type/procurements/pagination";
import { IconEye } from "@pentabd/icons";
import { useNavigate } from "react-router-dom";
import { useDemandById } from "@hooks/procurements/demand/useDemandById";
import { useSelectedProducts } from "@hooks/procurements/procurement/useSelectedProducts";

type SelectedProductType = {
  [key: string]: any;
  unitPrice: number;
  quantity: number;
};

export default function ProcurementDemandListTable({
  selectedProducts,
  handleSelectedDemand,
  demandIds,
  demands,
}: {
  selectedProducts: any;
  handleSelectedDemand: (id: number) => void;
  demandIds: number[];
  demands: any;
}) {
  const { t } = useTranslation();
  const { control } = useForm();
  const navigate = useNavigate();

  const { handleQuery, demandState } = useDemandList();

  const { getData, createSuccess, deleteSuccess } = demandState;

  const { data, pagination } = getData || ({} as DemandResponseType);
  const { page, total, size } = pagination || ({} as Pagination);

  // get products as per demand
  const { handleQueryById, demandState: singleDemandState } = useDemandById();

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess]);

  return (
    <>
      <Table
        header={{
          title: t("PROCUREMENT_DEMAND.DEMAND_LIST.TABLE_HEADING"),
          // buttons: [
          //   <SearchBox
          //     key="search"
          //     control={control}
          //     handleQuery={() => console.log()}
          //   />,
          // ],
          badge: {
            label: `${demands ? demands.length : total}`,
            size: "sm",
            type: "primary",
          },
        }}
        columns={ProcurementDemandListTableColumn(
          t,
          handleSelectedDemand,
          demandIds,
          demands,
        )}
        rows={demands ? demands : data || []}
        pagination={{
          totalPage: demands ? 0 : Math.ceil(total / size),
          onClick: (currentPage) => {
            handleQuery("page", currentPage);
          },
          activePage: page,
        }}
      />
    </>
  );
}
